module.exports = __webpack_public_path__ + "edit-icon.56afc801e38da92116f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/edit-icon.svg
// module id = ./src/assets/svgs/edit-icon.svg
// module chunks = main